import axios from "axios";
import { goldToast } from "gold-ui-kit";
import CONFIG from "../config";
import { store } from "../store";
import { resetAuth } from "../store/slices/authSlice";

const employeeapi = axios.create({
  timeout: 10000,
  baseURL: CONFIG.employeeApi,
});

employeeapi.interceptors.request.use(
  (config) => {
    const token = store.getState()?.auth?.token;
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

employeeapi.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { status, response } = error;

    let data = response?.data;

    if (data instanceof Blob) {
      try { data = JSON.parse(await data.text()) } catch { data = null }
    }

    switch (status) {
      case 400:
        if (data?.ExceptionMessage) {
          goldToast.error(data.ExceptionMessage, { title: "Hata (400)" });
        }
        break;
      case 422:
        goldToast.error(data?.Message || "Gönderilen veri formatı geçersiz.", { title: "Doğrulama Hatası (422)" });
        break;
      case 500:
        goldToast.error(data?.ExceptionMessage || "Beklenmedik bir sunucu hatası oluştu.", { title: "Sunucu Hatası (500)" });
        break;
      case 401: {
        if (error.config?._skip401Handler) {
          return Promise.reject(error);
        }
        window.dispatchEvent(new CustomEvent('auth-failed'));
        break;
      }
      default:
        goldToast.error("Bağlantı başarısız, İnternet bağlantınızı kontrol edin.", { title: "Bağlantı Hatası" });
        break;
    }

    return Promise.reject(error);
  }
);

export default employeeapi;
